import { utils, VideoData, VideoEventProvider } from '@ad-engine/core';
import { jwpLogGroupName } from './index';

export class JwpTracker {
	track(eventName: string, payload?: object) {
		utils.logger(jwpLogGroupName, 'tracking: ', eventName);
		this.sendInfo(eventName, payload);
	}

	private sendInfo(eventName: string, payload?: object) {
		const videoData: VideoData = {
			ad_error_code: 0,
			event_name: eventName,
			player: 'jwp',
			ad_product: 'outstream',
			position: 'incontent_player',
			line_item_id: 'unknown',
			creative_id: 'unknown',
		};
		const dataForDataWarehouse = VideoEventProvider.getEventData({
			...videoData,
			...payload,
		});

		VideoEventProvider.emit(dataForDataWarehouse);
		VideoEventProvider.emitVideoEvent(dataForDataWarehouse);
	}
}
